<template>
    <div>
       
        <el-form ref="form" :model="form" >
            <el-form-item label="玩家ID:">
                <el-input
                type="textarea"
                rows="10"
                v-model="form.uidList"
                placeholder="每行放1个ID"
                style="width: 300px">
                </el-input>
            </el-form-item>
        </el-form>
         <el-radio-group v-model="radio" >
            <el-radio-button
                v-for="(item, index) in recover"
                :label="item.value"
                :key="index"
                >{{ item.label }}</el-radio-button
            >
        </el-radio-group>
        <br>
        <br>
        <br>
        <el-button type="primary" icon="el-icon-s-promotion" @click="submit()" 
        >恢复次数</el-button
        >
    </div>
</template>

<script>
const axios = require("axios");
const util = require("../../util");
export default{
   data(){
       return{
        form: {
            uidList:"",
            
        },
        radio: "recoverArchiveUploadFrequency",
        recover: [
            { label: "上传次数恢复", value: "recoverArchiveUploadFrequency" },
            { label: "下载次数恢复", value: "recoverArchiveDownloadFrequency" },
        ],
   };
   },
    /**
     * url改变
     */
    methods:{
        /**
         * 解析玩家ID集合
         *
         * @returns {list: [], err: "xxxx"}
         */
        parseUidList() {
            let list = [];
            let uidListStr = this.form.uidList.trim();
            if (uidListStr.length > 0) {
                let arr = uidListStr.split(/\s+/);
                for (let e of arr) {
                let uid = Number(e);
                if (isNaN(uid) || uid != parseInt(uid)) {
                    return {
                    list: [],
                    err: "玩家ID格式错误",
                    };
                }

                if (uid <= 0) {
                    return {
                    list: [],
                    err: "玩家ID必须是正整数",
                    };
                }

                list.push(uid);
                }
            }

            if (list.length == 0) {
                return {
                list: [],
                err: "请输入玩家ID",
                };
            }

            return {
                list: list,
            };
        },
        async submit(){
            if (this.url == ""){
                this.$message({
                    message: "请选择功能",
                    type: "error",
                });
                return;
            }
            let uidList = [];
            let parseResult = this.parseUidList();
             if (parseResult.err) {
                this.$message({
                    message: parseResult.err,
                    type: "error",
                });
                return;
            }
            uidList = parseResult.list;

            let resData = (
                await axios.post(
                    `${util.getBackendApiBase()}/v1/${this.radio}`,
                    {
                        uidList: uidList,   
                    },
                    {
                        headers: {
                            token: util.getLoginUserToken(),
                        },
                    }
                 )
            ).data;
            if (resData.data.code > 0){
                this.$message.error(resData.message);
                return;
            }
            
            this.$message(
                    {
                        message:"恢复成功",
                        type:"success",
                    }
                );
            return this.form.uidList = resData.data.uidLis;
        }
    },
};
</script>
